import type { Feature } from 'ol';
import type { Coordinate } from 'ol/coordinate';
import { getCenter } from 'ol/extent';
import type { Geometry } from 'ol/geom';
import SimpleGeometry from 'ol/geom/SimpleGeometry';

export function createPastedFeature(
  clipboardFeature: Feature<Geometry>,
  targetCoordinate: Coordinate | undefined,
  offset: Coordinate = [0, 0],
): Feature<Geometry> {
  const pastedFeature = clipboardFeature.clone();
  pastedFeature.setId(undefined);
  pastedFeature.set('id', undefined);

  const geometry = pastedFeature.getGeometry();
  if (!(geometry instanceof SimpleGeometry)) {
    return pastedFeature;
  }

  if (!targetCoordinate) {
    geometry.translate(offset[0], offset[1]);
    return pastedFeature;
  }

  const extent = geometry.getExtent();
  if (extent.some(coordinate => !Number.isFinite(coordinate))) {
    return pastedFeature;
  }

  const [featureCenterX, featureCenterY] = getCenter(extent);
  geometry.translate(
    targetCoordinate[0] - featureCenterX + offset[0],
    targetCoordinate[1] - featureCenterY + offset[1],
  );

  return pastedFeature;
}
